var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIRejected = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -52.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 52.929)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.073 25.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 8.017,
    transform: "translate(-28.26 33.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.017,
    height: 1,
    transform: "translate(-28.26 38.351) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.007,43.125H-30.138a2.192,2.192,0,0,1-2.189-2.189V30.806a2.192,2.192,0,0,1,2.189-2.189h10.131a2.191,2.191,0,0,1,2.188,2.189v10.13A2.191,2.191,0,0,1-20.007,43.125ZM-30.138,29.617a1.19,1.19,0,0,0-1.189,1.189v10.13a1.19,1.19,0,0,0,1.189,1.189h10.131a1.19,1.19,0,0,0,1.188-1.189V30.806a1.19,1.19,0,0,0-1.188-1.189Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIRejected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_rejected.aaf3dc6e.svg";
export { ForwardRef as ReactComponent };